import {flow} from 'lodash/fp';
import React from 'react';
import {connect} from 'react-redux';
import ISQAOpen from '../../validate/ISQAOpen';
import connectQuests from './common/connectQuests';
import {EventQuestsPostQuestion} from './EventQuestsPostQuestion';

class EventQuestsEditQuestion extends EventQuestsPostQuestion {
    submitQuestion(content, anonymous, categoryId, attachments) {
        return app.api.questions.updateQuestion(this.props.eventId, this.props.questionId, content, anonymous, attachments);
    }
}

const ConnectedComponent = flow(
    connectQuests,
    connect((state, props) => ({
        question: state.events[props.eventId].questions.indexed[props.questionId],
    }))
)(EventQuestsEditQuestion);

export default props => (
    <ISQAOpen eventId={props.match.params.eventId}>
        <ConnectedComponent {...props.match.params} />
    </ISQAOpen>
);
